import { useState } from "react";
import { fileToResizedDataUrl } from "../lib/image";

// Champ d'image réutilisable (coachs, salles…) : import depuis l'appareil
// (redimensionné en data URL), aperçu, retrait, et URL externe en repli.
export function PhotoField({
  label = "Photo",
  value,
  onChange,
}: {
  label?: string;
  value: string;
  onChange: (photoUrl: string) => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = ""; // permet de re-sélectionner le même fichier
    if (!file) return;
    setError(null);
    setBusy(true);
    try {
      const dataUrl = await fileToResizedDataUrl(file);
      onChange(dataUrl);
    } catch {
      setError("Impossible de lire cette image.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-md border border-ink-300 p-3">
      <span className="mb-2 block text-sm font-semibold">{label}</span>
      <div className="flex items-start gap-3">
        {value ? (
          <img
            src={value}
            alt="Aperçu"
            className="h-20 w-20 shrink-0 rounded-md object-cover"
          />
        ) : (
          <div className="grid h-20 w-20 shrink-0 place-items-center rounded-md bg-ink-100 text-xs text-ink-500">
            Aucune
          </div>
        )}
        <div className="min-w-0 flex-1 space-y-2">
          <label className="btn-outline inline-block cursor-pointer">
            {busy ? "Traitement…" : value ? "Changer l'image" : "Importer une image"}
            <input
              type="file"
              accept="image/*"
              className="hidden"
              disabled={busy}
              onChange={handleFile}
            />
          </label>
          {value && (
            <button
              type="button"
              onClick={() => onChange("")}
              className="btn-ghost ml-2 text-brand-500"
            >
              Retirer
            </button>
          )}
          <input
            className="input"
            placeholder="…ou colle une URL d'image"
            value={value.startsWith("data:") ? "" : value}
            onChange={(e) => onChange(e.target.value)}
          />
          {value.startsWith("data:") && (
            <p className="text-xs text-ink-500">Image importée depuis l'appareil.</p>
          )}
          {error && <p className="text-xs text-brand-500">{error}</p>}
        </div>
      </div>
    </div>
  );
}
